<script setup lang="ts">
const { color = 'black' } = defineProps<{ color?: string }>();
</script>

<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.41406 26L25.4141 2"
      :stroke="color"
      stroke-width="4"
      stroke-linejoin="round"
    />
    <path d="M1.41406 2H25.4141V26" :stroke="color" stroke-width="4" />
  </svg>
</template>
